// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + ".js?id=" + {"349":"c05572b3906f1f1aa4f1","372":"ceb673f93f18999fe391","478":"8c86a1443f1480a13e78","627":"47e1081645706dc65553","770":"262d37a20de074610eb5"}[chunkId] + "";
};